import { defineStore } from 'pinia'

const STORE_NAME = 'jwt'

// Note that this storage is set up as sessionStorage
export const useJwtStore = defineStore(STORE_NAME, {
  state: () => ({
    token: null as string | null,
    tokenExpiresAt: null as string | null,
    refreshToken: null as string | null,
    refreshTokenExpiresAt: null as string | null,
  }),

  getters: {
    checkTokenIsValid: (state) => () => {
      if (!state.token) {
        return false
      }
      const deadline = new Date(state.tokenExpiresAt as string)
      // Bring the deadline one minute forward
      deadline.setMinutes(deadline.getMinutes() - 1)
      return new Date() < deadline
    },
    checkRefreshTokenIsValid: (state) => () => {
      if (!state.refreshToken) {
        return false
      }
      const deadline = new Date(state.refreshTokenExpiresAt as string)
      // Bring the deadline one minute forward
      deadline.setMinutes(deadline.getMinutes() - 1)
      return new Date() < deadline
    },
  },

  actions: {
    setTokens({ token, tokenExpiresAt, refreshToken, refreshTokenExpiresAt }: { token: string; tokenExpiresAt: string; refreshToken: string; refreshTokenExpiresAt: string }) {
      this.token = token
      this.tokenExpiresAt = tokenExpiresAt
      this.refreshToken = refreshToken
      this.refreshTokenExpiresAt = refreshTokenExpiresAt
    },

    reset() {
      if (this.token) this.token = null
      if (this.tokenExpiresAt) this.tokenExpiresAt = null
      if (this.refreshToken) this.refreshToken = null
      if (this.refreshTokenExpiresAt) this.refreshTokenExpiresAt = null
    },
  },

  persist: {
    storage: piniaPluginPersistedstate.sessionStorage(),
    key: `db-${STORE_NAME}`,
  },
})
